/**
 *  MissilePowerup
 *
 *  Created by Legman on 20/04/2017.
 *
 */

import Common from "../Common";
import Missile from "./Missile";
import Powerup from "./Powerup";

/**
 * @class
 * @extends Powerup
 */
export default class MissilePowerup extends Powerup {
    /**
     * @param collector
     */
    constructor(collector) {
        super(collector);

        /**
         * @type {Missile}
         * @protected
         */
        this._missile = null;
    }

    /**
     */
    init() {
        super.init();
    }

    /**
     */
    destroy() {
        super.destroy();
    }

    /**
     * @param {number} dt
     */
    update(dt) {
        super.update(dt);

        if (this._missile && this._missile.destroyNextFrame) {
            this.destroyNextFrame = true;
        }
    }

    /**
     * @returns {boolean}
     */
    activate() {
        const activated = super.activate();
        if (activated) {
            this._missile = this._createMissile(this._collector);
            this._missile.powerupType = this.type;
            this._missile.offset.x = this._collector.offset.x;
            this._missile.offset.y = -120;
            this._missile.moving = true;
            this._missile.lap = this._collector.lap;
            this._collector.engine.addEntity(this._missile, this._collector.distance + 0.2, false);

            delay(function() {
                this._collector.usingPowerup = false;
            }, 2, this);

            this._collector.view.visible && Common.audio.playSound(["sfx_launch_missile_00", "sfx_launch_missile_01"]);
        }
        return activated;
    }

    /**
     * @param {RaceCar} collector
     * @returns {Missile}
     * @private
     */
    _createMissile(collector) {
        return new Missile(collector);
    }

    /**
     * @returns {Missile}
     */
    get missile() {
        return this._missile;
    }
}